/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import { ArrayControlProps } from '@jsonforms/core';
import React from 'react';
import { Grid, GridItem, IconButton, Td, Tooltip, Tr } from '@chakra-ui/react';
import ChakraTableCell from './ChakraTableCell';
import { generateCells } from './utils';
import Icons from '@/components/icons/Icons';

interface ChakraTableRowProps extends Pick<ArrayControlProps, 'enabled' | 'cells' | 'schema'> {
    childPath: string;
    rowIndex: number;
    enableUp: boolean;
    enableDown: boolean;
    showSortButtons: boolean;
    moveUp?(): void;
    moveDown?(): void;
    removeItem?(): void;
}

const ChakraTableRow = ({
    childPath,
    schema,
    moveUp,
    moveDown,
    enableUp,
    enableDown,
    showSortButtons,
    enabled,
    cells,
    removeItem,
}: ChakraTableRowProps) => {
    return (
        <Tr key={childPath}>
            {generateCells(ChakraTableCell, schema, childPath, enabled, cells)}
            <Td>
                {enabled ? (
                    <Grid gap={4} gridAutoFlow="column" justifyContent="right" alignItems="center">
                        {showSortButtons ? (
                            <>
                                <GridItem gridColumn="1">
                                    <Tooltip label="Move up">
                                        <IconButton
                                            aria-label="Move up"
                                            onClick={moveUp}
                                            disabled={!enableUp}
                                            size="xs"
                                            icon={<Icons.PointerUpIcon />}
                                        />
                                    </Tooltip>
                                </GridItem>
                                <GridItem gridColumn="1">
                                    <Tooltip label="Move down">
                                        <IconButton
                                            aria-label="Move down"
                                            onClick={moveDown}
                                            disabled={!enableDown}
                                            size="xs"
                                            icon={<Icons.PointerDownIcon />}
                                        />
                                    </Tooltip>
                                </GridItem>
                            </>
                        ) : null}
                        <GridItem gridRow="span 2">
                            <Tooltip label="Delete">
                                <IconButton
                                    colorScheme="red"
                                    aria-label="Delete"
                                    variant="outline"
                                    icon={<Icons.CloseIcon w={8} h={8} />}
                                    onClick={removeItem}
                                />
                            </Tooltip>
                        </GridItem>
                    </Grid>
                ) : null}
            </Td>
        </Tr>
    );
};

export default ChakraTableRow;
